export default __webpack_public_path__ + "static/media/menu-open_black.2b8a3130.svg";